import { render, staticRenderFns } from "./realTimeInfo.vue?vue&type=template&id=91f190e4&scoped=true&"
import script from "./realTimeInfo.vue?vue&type=script&lang=js&"
export * from "./realTimeInfo.vue?vue&type=script&lang=js&"
import style0 from "./realTimeInfo.vue?vue&type=style&index=0&id=91f190e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91f190e4",
  null
  
)

export default component.exports